import { createDefaultTyrann } from '@apis/common';
import * as t from 'io-ts';

export const utilsApis = createDefaultTyrann({
  '/generate-error/{status}/': {
    get: {
      path: t.type({
        status: t.number,
      }),
      response: {
        200: t.type({
          detail: t.string,
        }),
      },
    },
  },
  '/generate-error/200/': {
    get: {
      response: {
        200: t.type({
          missing: t.string,
        }),
      },
    },
  },
});
